if (!customElements.get('pdp-accordion-tabs')) {
  class PdpAccordionTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = Array.from(this.querySelectorAll('.pdp-accordion__tab-btn'));
      this.panels = Array.from(this.querySelectorAll('.pdp-accordion__panel'));
    }

    connectedCallback() {
      this.buttons.forEach((btn) => {
        btn.addEventListener('click', (e) => this.onTabClick(e));
      });
    }

    onTabClick(event) {
      const target = event.currentTarget;
      const index = parseInt(target.dataset.index, 10);
      if (Number.isNaN(index)) return;
      this.activate(index);
    }

    activate(index) {
      this.buttons.forEach((btn) => {
        const isActive = parseInt(btn.dataset.index, 10) === index;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        const isActive = parseInt(panel.dataset.index, 10) === index;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }
  }

  customElements.define('pdp-accordion-tabs', PdpAccordionTabs);
}
